import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { LogService } from '@app/services';

import { AttachmentMetadata } from '../../models';
import { AttachmentService } from '../../services/attachment.service';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'images-carousel',
    templateUrl: './images-carousel.component.html',
    styleUrls: ['./images-carousel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgStyle]
})
export class CarouselComponent implements AfterContentInit, AfterViewInit, OnDestroy {
  constructor(element: ElementRef, readonly attachmentService: AttachmentService, private log: LogService) {
    this.element = element.nativeElement;
  }

  hammerInitialized = false;

  intervalRef = undefined;

  element: HTMLElement;

  _activeIndex = 0;

  get activeIndex() {
    return this._activeIndex;
  }
  set activeIndex(value) {
    if (this.images.length === 0) {
      this._activeIndex = -1;
      return;
    }
    this._activeIndex = value;
    if (this._activeIndex >= 0) {
      this.img = this.images[this._activeIndex];
    }
  }

  @Output() onImageClick = new EventEmitter<AttachmentMetadata>();
  @Input() useThumbnails = false;
  @Input() images: AttachmentMetadata[];
  @Input() listingId: number;
  @Input() defaultImageId: number;
  @Input() height;
  @Input() cssClass: string[];

  /**
   * Currently selected image, shown in foreground
   */
  img: AttachmentMetadata;

  @Input() set interval(value: number) {
    if (this.intervalRef !== undefined) {
      clearInterval(this.intervalRef);
      this.intervalRef = undefined;
    }

    if (value > 0) {
      setInterval(() => {
        this.next();
      }, value);
    }
  }

  ngAfterContentInit() {
    if (this.defaultImageId) {
      this.activeIndex = this.images.findIndex((i) => i.id === this.defaultImageId);
    } else {
      this.activeIndex = 0;
    }
    this.img = this.images[this.activeIndex];
  }

  ngAfterViewInit() {
    if (!this.hammerInitialized && typeof Hammer !== 'undefined') {
      const hammerElement = new Hammer(this.element);
      hammerElement.on('swiperight', () => {
        this.prev();
      });
      hammerElement.on('swipeleft', () => {
        this.next();
      });

      this.hammerInitialized = true;
    }
  }

  ngOnDestroy() {
    if (this.intervalRef !== undefined) {
      clearInterval(this.intervalRef);
      this.intervalRef = undefined;
    }
  }

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  buildAttachmentUrl(): string {
    if (this.verboseLogging) {
      console.log('buildAttachmentUrl()...');
    }

    this.img.listingId = this.listingId;

    if (this.img && this.img.id && this.img.listingId) {
      const { contentUpdatedOn, id: attachmentId, listingId } = this.img;
      return this.attachmentService.attachmentUrl({
        contentUpdatedOn,
        attachmentId,
        listingId,
        thumb: this.useThumbnails,
      });
    }

    console.log('...buildAttachmentUrl(): no image found.');
    //return '/assets/images/no-image.jpg';
  }
  /* use this method to pass any  css classes you want to use */
  get cssClasses() {
    if (this.cssClass) {
      if (this.cssClass.length > 0) {
        return this.cssClass.join(' ');
      }
    }
    return;
  }
  getRelativeItem(rel: number) {
    return this.images.length === 1 ? this.images[0] : this.images[this.getRelativeIndex(rel)];
  }

  getRelativeIndex(rel: number) {
    const target = this.activeIndex + rel;

    if (this.images.length === 0) {return;}

    if (target < 0) {
      return this.images.length - 1;
    } else if (target > this.images.length - 1) {
      return 0;
    }
    return target;
  }

  navigateTo(index: number) {
    this.activeIndex = index;
  }

  prev() {
    if (this.images.length > 1) {
      this.activeIndex = this.getRelativeIndex(-1);
      //this.change.markForCheck();
    }
  }

  next() {
    if (this.images.length > 1) {
      this.activeIndex = this.getRelativeIndex(1);
      //this.change.markForCheck();
    }
  }

  swipeleft() {
    this.next();
  }

  swiperight() {
    this.prev();
  }
}
